const YOUTUBE_REGEX = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/;

function _loadYoutubeApi() {
  const tag = document.createElement('script');
  tag.src = 'https://www.youtube.com/iframe_api';
  const firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}

class YouTubeApi {
  constructor() {
    this._isLoaded = false;
    this._isLoading = false;
    this._loadedCallbacks = [];
  }

  getVideoIdFromUrl(videoUrl) {
    if (!videoUrl) {
      return null;
    }

    const match = videoUrl.match(YOUTUBE_REGEX);
    if (!match || match[2].length !== 11) {
      return null;
    }

    return match[2];
  }

  init(initCallback) {
    if (initCallback) {
      this._loadedCallbacks.push(initCallback);
    }

    if (this._isLoading) {
      return;
    }

    if (this._isLoaded) {
      this.youTubeApiReady();
      return;
    }

    this._isLoading = true;

    window.onYouTubeIframeAPIReady = this.youTubeApiReady.bind(this);
    _loadYoutubeApi();
  }

  youTubeApiReady() {
    this._loadedCallbacks.forEach(callback => {
      callback();
    });
    this._isLoaded = true;
    this._isLoading = false;
    this._loadedCallbacks = [];
  }
}

export default new YouTubeApi();
